// extracted by mini-css-extract-plugin
export default {"headerContainer":"MyClassroomsHeader_headerContainer__u9w7M","title":"MyClassroomsHeader_title__BoYhj","createClassroomButton":"MyClassroomsHeader_createClassroomButton__ltXmB"};